// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../types';
import { media } from '../../helpers';
import { Flex } from '../grid';
import AssortmentCarblock from './assortmentCarblock';

type Props = {|
  pdbIds: Array<string>,
|};

const FlexColumn = props => (
  <Flex
    px="1rem"
    py="0.7rem"
    {...props}
  />
);

const Column = styled<typeof FlexColumn, Theme>(FlexColumn)`
    width: 100%;
    ${media.md(css`
      width: 50%;
    `)}
    ${media.xl(css`
      width: 33.3333%;
    `)}
`;

const Assortment = ({
  pdbIds,
}: Props) => (
  <Flex width={1} wrap>
    {pdbIds.map(pdbId => (
      <Column key={pdbId}>
        <AssortmentCarblock pdbId={pdbId} />
      </Column>
    ))}
  </Flex>
);

export default Assortment;
